import { Route, Routes as RoutesContainer } from 'react-router';
import { Agent, Create, Edit } from '../index';

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/agent' element={<Agent />} />
      <Route exact path='/agent/create' element={<Create />} />
      <Route exact path='/agent/edit/:id' element={<Edit />} />
    </RoutesContainer>
  );
};
export default Routes;
